<template>
  <div>
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('paramInterneAdmin.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-addOrEdit" @click="editParams()">
              {{ $t('general.button.edit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
      <onglet-manager :onglets="onglets">
        <template v-slot:fonction="{ activeTab }">
          <parametre-interne-table
            :activeTab="activeTab"
            :params="tabParams"/>
        </template>
        <template v-slot:module="{ activeTab }">
          <parametre-interne-table
            :activeTab="activeTab"
            :params="tabParams"/>
        </template>
        <template v-slot:specifique="{ activeTab }">
          <parametre-interne-table
            :activeTab="activeTab"
            :params="tabParams"/>
        </template>
        <template v-slot:produit="{ activeTab }">
          <parametre-interne-table
            :activeTab="activeTab"
            :params="tabParams"/>
        </template>
        <template v-slot:gestionInterface>
          <gestion-interface />
        </template>
      </onglet-manager>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { changeSetting, get } from '@/api/settings';
import breadcrumb from '@/components/general/breadcrumb';
import messageSuccess from '@/services/general/messageSucces';
import { LOCALISATION_ADMIN } from '@/configuration/general/paramConf';
import ongletManager from '@/components/general/ongletManager';
import parametreInterneTable from '@/components/configInterne/parametreInterneTable';
import gestionInterface from '@/components/configInterne/gestionInterface';

const Parametres = createNamespacedHelpers('parametres');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      tabParams: [],
      activeTab: 'fonction',
    };
  },
  components: {
    breadcrumb,
    ongletManager,
    parametreInterneTable,
    gestionInterface,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('paramInterneAdmin.breadcrumb.parametrageInterne'), route: '', isActive: true },
      ];
    },
    filteredParams() {
      return this.tabParams.filter(p => p.modele === this.activeTab);
    },
    onglets() {
      return [
        {
          key: 'fonction',
          title: this.$t('paramInterneAdmin.tabs.fonction'),
        },
        {
          key: 'module',
          title: this.$t('paramInterneAdmin.tabs.module'),
        },
        {
          key: 'specifique',
          title: this.$t('paramInterneAdmin.tabs.specifique'),
        },
        {
          key: 'produit',
          title: this.$t('paramInterneAdmin.tabs.produit'),
        },
        {
          key: 'gestionInterface',
          title: this.$t('paramInterneAdmin.tabs.gestionInterface'),
        },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterneForce: 'loadParametreInterneForce',
    }),
    ...CategorieVente.mapActions({
      loadCategorieVente: 'loadCategories',
    }),
    async updateTabParams() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.tabParams = [];
        const promiseTabParam = [];
        const keys = [];
        Object.values(PARAMETRES_INTERNE_KEYS).forEach((param) => {
          if (param.localisation !== LOCALISATION_ADMIN) return;
          promiseTabParam.push(get(param.key));
          const cloneParam = cloneDeep(param);
          cloneParam.value = '';
          keys.push(cloneParam.key);
          this.tabParams.push(cloneParam);
        });
        const rsltParams = (await Promise.all(promiseTabParam));
        for (let i = 0; i < keys.length; i += 1) {
          const paramFind = this.tabParams.find((param) => {
            return param.key === keys[i];
          });
          if (!paramFind) return;
          paramFind.value = rsltParams[i].data.result;
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async editParams() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promiseParamUpdate = [];
        this.tabParams.forEach((param) => {
          promiseParamUpdate.push(changeSetting(param.key, param.value));
        });
        await Promise.all(promiseParamUpdate);
        const promiseForceUpdate = [];
        this.tabParams.forEach((param) => {
          promiseForceUpdate.push((this.loadParametresInterneForce(param.key)));
        });
        await Promise.all(promiseForceUpdate);
        await this.updateTabParams();
        await this.loadCategorieVente();
        messageSuccess(this.$i18n.t('paramInterneAdmin.messages.success.edit'));
        loadingComponent.close();
        await this.$router.go(0);
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.updateTabParams();
      this.setInformationPage(this.$t('pageConfigInterne.paramInterneAdmin.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
